import React from "react";
import { Box } from "@mui/material";
import NavBar from "../../../Components/Widgets/Navbar";
import MenuDrawer from "../../../Components/Widgets/MenuDrawer";
import Recipe from "../../../Components/Widgets/Recipe";
import Footer from "../widgets/footer";
import { useTheme } from "@mui/material/styles";

const ExportDefault = (props) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <NavBar
        {...{
          ...props,
          ...{},
        }}
      />
      <Box
        sx={{
          height: {
            xs: theme.appbar_height.mobile,
            md: theme.appbar_height.desktop,
          },
        }}
      />
      <MenuDrawer {...props} />
      <Recipe {...props} />
      <Footer {...props} />
    </Box>
  );
};

export default ExportDefault;
